import {css} from 'lit';
export const styles = css`:host {
  display: block;
  border-radius: var(--border-radius);
}

slot::slotted(*) {
  display: block;
  margin-top: 1px;
}

slot::slotted(*:first-child) {
  --el-border-radius: var(--border-radius) var(--border-radius) 0 0;
}

@media (min-width: 992px) {

slot::slotted(*:first-child) {
    --el-border-radius: 0
}
  }

slot::slotted(*:last-child) {
  --el-border-radius: 0 0 var(--border-radius) var(--border-radius);
}

@media (min-width: 992px) {

slot::slotted(*:last-child) {
    --el-border-radius: 0
}
  }
`;
export default styles;
